module.exports = __webpack_public_path__ + "img/arrow-right.9aac9141.svg";